import './Hero.css';

export default function Hero() {
  return (
    <section className="hero">
      {/* Background decorations */}
      <div className="hero__bg">
        <div className="hero__blob hero__blob--1" />
        <div className="hero__blob hero__blob--2" />
        <div className="hero__blob hero__blob--3" />
        <div className="hero__grid" />
      </div>

      <div className="container hero__inner">
        {/* Left: Text */}
        <div className="hero__content">
          <div className="hero__badge">
            <span className="hero__badge-dot" />
            🚀 Version bêta disponible
          </div>

          <h1 className="hero__title">
            Finies les <span className="hero__title-highlight">répétitions.</span><br />
            Place à l'<span className="hero__title-highlight hero__title-highlight--2">autonomie.</span>
          </h1>

          <p className="hero__subtitle">
            Evolify accompagne parents et enfants vers des routines durables, grâce à une gamification douce et bienveillante. Sans cris, sans frustration.
          </p>

          <div className="hero__stats">
            <div className="hero__stat">
              <span className="hero__stat-number">2 min</span>
              <span className="hero__stat-label">par jour max</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <span className="hero__stat-number">4-5</span>
              <span className="hero__stat-label">tâches / enfant</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <span className="hero__stat-number">100%</span>
              <span className="hero__stat-label">co-construit</span>
            </div>
          </div>

          <div className="hero__actions">
            <a href="#contact" className="btn-primary hero__btn-main">
              Rejoindre la bêta gratuite
              <span>→</span>
            </a>
            <a href="#fonctionnement" className="btn-secondary">
              <span>▶</span> Voir comment ça marche
            </a>
          </div>

          <p className="hero__note">Gratuit pendant la bêta · Aucune carte requise</p>
        </div>

        {/* Right: App mockup */}
        <div className="hero__visual">
          <div className="hero__phone-wrapper">
            {/* Phone shell with real screenshot inside */}
            <div className="hero__phone">
              <div className="hero__phone-notch" />
              <img
                src="/images/evolify-app-screen.jpg"
                alt="Aperçu de l'application Evolify"
                className="hero__phone-screen"
              />
            </div>

            {/* Floating cards */}
            <div className="hero__float hero__float--xp">
              <span className="hero__float-icon">⚡</span>
              <div>
                <p className="hero__float-title">+150 XP gagnés !</p>
                <p className="hero__float-sub">Faire son lit · Rare</p>
              </div>
            </div>

            <div className="hero__float hero__float--level">
              <span className="hero__float-icon">🎉</span>
              <div>
                <p className="hero__float-title">Niveau 8 débloqué !</p>
                <p className="hero__float-sub">Nouvelle carte à choisir</p>
              </div>
            </div>

            <div className="hero__float hero__float--evo">
              <span className="hero__float-icon">💜</span>
              <div>
                <p className="hero__float-title">Message d'Evo</p>
                <p className="hero__float-sub">"Bravo tu es super !"</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="hero__scroll">
        <div className="hero__scroll-mouse">
          <div className="hero__scroll-dot" />
        </div>
        <p>Découvrir</p>
      </div>
    </section>
  );
}
